// Lib
import React from 'react';

// Components
import PopupPanel from '../../../../../components/popupPanel/PopupPanel';
import DarkModeSuggestionPopupContent from './DarkModeSuggestionPopupContent';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const DarkModeSuggestionPopup = (props) => (
    <PopupPanel stayOpen popupId={PopupIds.DARK_MODE_SUGGESTION} className="DarkModeSuggestionPopup">
        <DarkModeSuggestionPopupContent {...props} />
    </PopupPanel>
);

export default DarkModeSuggestionPopup;
